import React from 'react'
import { ContainerField, ErrorText, FieldFormtTextArea } from '../styles'
import { IFieldForm } from '../type'

export const FiltFormTextArea = ({
    onBlur,
    value,
    onChange,
    id,
    touched,
    errors,
    title,
    ...rest
}: IFieldForm) => {
    return (
        <ContainerField>
            <FieldFormtTextArea
                id={id}
                placeholder={title}
                onChange={onChange}
                onBlur={onBlur}
                value={value}
                {...rest}
            />
            {errors && touched ? (
                <ErrorText variant={'h4'} fontSize={'small'}>
                    {errors}
                </ErrorText>
            ) : null}
        </ContainerField>
    )
}
